// src/config.js

const CONFIG = {
  region: process.env.REACT_APP_REGION,
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  providerPoolId: process.env.REACT_APP_PROVIDER_POOL_ID,
  providerPoolClientId: process.env.REACT_APP_COGNITO_PROVIDER_POOL_ID,
  userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID,
  apiEndpoint: process.env.REACT_APP_API_ENDPOINT,
  lambdaAppointment: process.env.REACT_APP_LAMBDA_APPOINTMENT,
  lambdaPatientLookup: process.env.REACT_APP_LAMBDA_PATIENT_LOOKUP,
  lambdaProviderLookup: process.env.REACT_APP_LAMBDA_PROVIDER_LOOKUP,
  awsUrl: process.env.REACT_APP_AWS_URL,
};

export default CONFIG;